@if (mode == 'table') {
    <app-generic-table
        [data]="iBaseCRUD?.items ?? []"
        [totalCount]="iBaseCRUD?.totalItemCount ?? -1"
        [cols]="iBaseCRUD?.tableCols ?? []"
        [entityName]="iBaseCRUD?.modelHumanName ?? 'Model'"
        [flexHeight]="flexHeight"
        [showColumnToggle]="showColumnToggle"
        [showSearch]="showSearch"
        [showRefreshButton]="true"
        [showHelpButton]="showHelpButton"
        [showNewButton]="showNewButton && iBaseCRUD!! && iBaseCRUD.isNewAllowed && iBaseCRUD.modalType != null"
        [showTableLoading]="(iBaseCRUD?.showLoading || iBaseCRUD?.parentShowingLoading) ?? false"
        [showTableError]="iBaseCRUD?.showError ?? false"
        [defaultPaginatorConfig]="defaultPaginatorConfig"
        [tableLoadingStr]="iBaseCRUD?.loadingStr ?? 'Loading'"
        [showPaginator]="showTablePaginator"
        (refreshEvent)="iBaseCRUD?.refresh()"
        (helpEvent)="iBaseCRUD?.onHelp()"
        (newEvent)="iBaseCRUD?.onNew()"
        (contextMenuSelectEvent)="iBaseCRUD?.onContextMenuSelect($event)"
        [contextMenu]="iBaseCRUD?.contextMenu"
    >
    </app-generic-table>
} @else if (mode == 'tree') {
    <app-generic-tree
        [data]="iBaseCRUD?.treeItems ?? []"
        [cols]="iBaseCRUD?.treeCols ?? []"
        [entityName]="iBaseCRUD?.modelHumanName ?? 'Model'"
        [flexHeight]="flexHeight"
        [showColumnToggle]="showColumnToggle"
        [showSearch]="showSearch"
        [showRefreshButton]="true"
        [showHelpButton]="showHelpButton"
        [showNewButton]="showNewButton && iBaseCRUD!! && iBaseCRUD.isNewAllowed && iBaseCRUD.modalType != null"
        [showTreeLoading]="(iBaseCRUD?.showLoading || iBaseCRUD?.parentShowingLoading) ?? false"
        [showTreeError]="iBaseCRUD?.showError ?? false"
        [defaultPaginatorConfig]="defaultPaginatorConfig"
        [treeLoadingStr]="iBaseCRUD?.loadingStr ?? 'Loading'"
        [selectionMode]="treeSelectionMode"
        (refreshEvent)="iBaseCRUD?.refresh()"
        (helpEvent)="iBaseCRUD?.onHelp()"
        (newEvent)="iBaseCRUD?.onNew()"
        (selectionChangeEvent)="iBaseCRUD?.onTreeSelectionChanged($event)"
        (contextMenuSelectEvent)="iBaseCRUD?.onContextMenuSelect($event)"
        [contextMenu]="iBaseCRUD?.contextMenu"
        [selection]="treeSelection"
    >
    </app-generic-tree>
}
